/* eslint-disable */
import createIcon from '../createIcon';

const IconTableSortOutlined = createIcon({
  name: 'icon-table-sort-outlined',
  content: '<title>表格/表头/排序</title><g stroke-width="1" fill="none" fill-rule="evenodd"><path d="M543.760379,581 L543.76,803.615158 L708.779404,638.302819 L754.074363,683.517493 L511.794901,926.227158 L269,683.889454 L314.212165,638.591991 L479.76,803.828158 L479.760379,581 L543.760379,581 Z M511.794901,97 L754.074363,339.709665 L708.779404,384.924338 L543.76,219.612 L543.760379,442.227158 L479.760379,442.227158 L479.76,219.399 L314.212165,384.635166 L269,339.337704 L511.794901,97 Z" fill="currentColor" fill-rule="nonzero"/></g>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconTableSortOutlined;
